var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
export function renamespaceValue(value, namespaceMap) {
    return Object.entries(namespaceMap).reduce(function (acc, _a) {
        var _b = __read(_a, 2), matchKey = _b[0], replaceString = _b[1];
        if (acc.startsWith(matchKey)) {
            var matchRegex = new RegExp("^" + matchKey);
            acc = acc.replace(matchRegex, replaceString);
        }
        return acc;
    }, value || '');
}
export function renamespaceKeys(entry, namespaceMap) {
    // Iterate through key value pairs
    return Object.entries(entry)
        .reduce(function (result, _a) {
        var _b = __read(_a, 2), sourceKey = _b[0], sourceValue = _b[1];
        var newKey = renamespaceValue(sourceKey, namespaceMap);
        result[newKey] = sourceValue;
        return result;
    }, {});
}
